import { utils } from 'components/lexemes';
import Localization from 'lib/localization';

export default {
  tab: {
    title() {
      return Localization.get('bumblesite@privacy.contactUs.tab.title');
    },
    text() {
      return Localization.get('bumblesite@privacy.contactUs.tab.description');
    },
    contents: {
      title() {
        return Localization.get('bumblesite@privacy.informationDisclosure.tab.contents.title');
      },
      item1() {
        return Localization.get('bumblesite@privacy.contactUs.tab.contents.item1');
      },
    },
  },
  section1: {
    text1() {
      return Localization.get('bumblesite@privacy.contactUs.section1.text1');
    },
    text2() {
      return Localization.get('bumblesite@privacy.contactUs.section1.text2');
    },
    text3() {
      return Localization.get('bumblesite@privacy.contactUs.section1.text3', {
        feedback_url: utils.getLinkMarkerUrl('feedback_url'),
        gdpr_request_url: utils.getLinkMarkerUrl('gdpr_request_url'),
      });
    },
    text4({ printable_version_link }: { printable_version_link: string }) {
      return Localization.get('bumblesite@privacy.contactUs.section1.text4', {
        printable_version_link,
      });
    },
  },
};
